import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * Route wrapper that gates the authenticated SaaS workspace.
 * - While the session is being validated we show a branded splash instead of
 *   flashing the login screen on every hard reload.
 * - Unauthenticated visitors are redirected to /login preserving the intended
 *   destination in location.state.from so login can resume the journey.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-[#0b0f19]">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center text-2xl shadow-lg shadow-blue-900/20 mb-4">
          🔐
        </div>
        <LoadingSpinner message="Validating session..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
